import CreateNewsModal from './CreateNewsModal';

export default CreateNewsModal;
